import { Stack } from "@/core/components/ui/stack/stack";
import { Typography } from "@/core/components/ui/typography";

interface SpiffRuleTextProps {
  title: string;
  description: string;
}

export const SpiffRuleText = ({ title, description }: SpiffRuleTextProps) => (
  <Stack className="gap-3">
    <Typography variant="subtitleW2">{title}</Typography>
    <Typography variant="bodyW2" textColor="secondary">
      {description}
    </Typography>
  </Stack>
);
